import { StatoNotaEnum } from "./shared/enum/stato-nota-enum";

export const constants: any = {};
constants.PARAM_ID = "id";
constants.PATH_CLONA_ATTO = "clona";
constants.ROUTE_CLONA_ATTO = `${constants.PATH_CLONA_ATTO}/:${constants.PARAM_ID}`;
constants.PATH_CLONA_NOTA = "clona";
constants.ROUTE_CLONA_NOTA = `${constants.PATH_CLONA_NOTA}/:${constants.PARAM_ID}`;

export const CLONA_NOTA_ALLOWED_STATES: StatoNotaEnum[] = [
  StatoNotaEnum.APPROVATO,
  StatoNotaEnum.RITIRATO,
  StatoNotaEnum.PAGATO,
];
